
export enum AppActionType {
  UpdateReadyState = 'app/updateReadyState',
  AddMetadata = 'app/addMetadata'
};
